import styled from 'styled-components';

export const FlexBox = styled.div`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  ${props => props.justify ? `justify-content: ${props.justify};` : ``}
  ${props => props.align ? `align-items: ${props.align};` : ``}
`;

export const Flex = styled.div`
  flex: ${props => `${props.flex ?? 1} ${props.flex ?? 1}`} 10px;
`;
